import {
  FaHome, FaBuilding, FaMapMarkerAlt, FaPhone, FaEnvelope, FaStar, FaStarHalfAlt,
  FaCheck, FaCheckCircle, FaShieldAlt, FaUsers, FaUser, FaUserTie, FaKey,
  FaDollarSign, FaChartLine, FaClock, FaCalendarAlt, FaCar, FaBed, FaBath,
  FaRulerCombined, FaWifi, FaSwimmingPool, FaDumbbell, FaParking, FaTree,
  FaLeaf, FaSun, FaMoon, FaCamera, FaVideo, FaImage, FaFileAlt, FaDownload,
  FaUpload, FaSearch, FaFilter, FaHeart, FaThumbsUp, FaComment, FaShareAlt,
  FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaWhatsapp,
  FaLine, FaGlobe, FaLanguage, FaAward, FaMedal, FaTrophy, FaHandshake,
  FaBriefcase, FaCity, FaMountain, FaUmbrellaBeach, FaPlane, FaShip, FaBus,
  FaTrain, FaBicycle, FaWalking, FaWheelchair, FaChild, FaDog, FaCat,
  FaUtensils, FaCoffee, FaShoppingCart, FaTag, FaTags, FaGift, FaGem,
  FaCrown, FaFire, FaBolt, FaSnowflake, FaCloud, FaCloudSun, FaSync,
  FaCog, FaTools, FaWrench, FaHammer, FaPaintRoller, FaRuler, FaCompass,
  FaMap, FaMapMarkedAlt, FaRoute, FaDirections, FaArrowRight, FaArrowLeft,
  FaChevronRight, FaChevronLeft, FaChevronDown, FaChevronUp, FaPlus,
  FaMinus, FaTimes, FaInfoCircle, FaExclamationCircle, FaQuestionCircle,
  FaLightbulb, FaRocket, FaChartBar, FaChartPie, FaPercentage, FaCalculator,
  FaCreditCard, FaWallet, FaPiggyBank, FaHandHoldingUsd, FaBalanceScale,
  FaGavel, FaUniversity, FaSchool, FaGraduationCap, FaBook, FaBookmark,
  FaNewspaper, FaRss, FaBell, FaLock, FaUnlock, FaEye, FaEyeSlash,
  FaThumbtack, FaFlag, FaAnchor, FaLifeRing, FaFirstAid, FaHeartbeat,
  FaStethoscope, FaDoorOpen, FaConciergeBell, FaMoneyBillWave, FaSearchLocation, FaMoneyBill, FaClipboardCheck, 
  FaTiktok, FaLayerGroup, FaFileContract, FaComments, FaCalendarCheck, FaPencilRuler, FaFileInvoiceDollar, 
  FaBullhorn, FaUserCheck, FaHouseUser, FaStore, FaBalanceScaleLeft, FaExchangeAlt, FaChess, FaGlobeAsia, 
  FaPercent, FaScroll, FaLandmark, FaFileSignature, FaCoins, FaSuitcase, FaBroom, FaTshirt, FaChalkboardTeacher, FaClipboardList
} from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'

// Curated, explicitly-named subset of react-icons/fa. Named imports (unlike
// `import * as FaIcons`) let the bundler tree-shake — only icons referenced
// below ship in the client bundle, instead of the whole ~1,500-icon set
// (~300KB+ unminified). Both the admin IconPicker and the public
// HomePageRenderer read from this same map, so anything selectable in the
// editor is guaranteed to render on the live site.
//
// Need an icon that isn't here? Add the named import above and the key
// below — each addition is a small, real bundle cost, not a bulk import.
export const FA_ICON_MAP = {
  FaHome, FaBuilding, FaMapMarkerAlt, FaPhone, FaEnvelope, FaStar, FaStarHalfAlt,
  FaCheck, FaCheckCircle, FaShieldAlt, FaUsers, FaUser, FaUserTie, FaKey,
  FaDollarSign, FaChartLine, FaClock, FaCalendarAlt, FaCar, FaBed, FaBath,
  FaRulerCombined, FaWifi, FaSwimmingPool, FaDumbbell, FaParking, FaTree,
  FaLeaf, FaSun, FaMoon, FaCamera, FaVideo, FaImage, FaFileAlt, FaDownload,
  FaUpload, FaSearch, FaFilter, FaHeart, FaThumbsUp, FaComment, FaShareAlt,
  FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaWhatsapp,
  FaLine, FaGlobe, FaLanguage, FaAward, FaMedal, FaTrophy, FaHandshake,
  FaBriefcase, FaCity, FaMountain, FaUmbrellaBeach, FaPlane, FaShip, FaBus,
  FaTrain, FaBicycle, FaWalking, FaWheelchair, FaChild, FaDog, FaCat,
  FaUtensils, FaCoffee, FaShoppingCart, FaTag, FaTags, FaGift, FaGem,
  FaCrown, FaFire, FaBolt, FaSnowflake, FaCloud, FaCloudSun, FaSync,
  FaCog, FaTools, FaWrench, FaHammer, FaPaintRoller, FaRuler, FaCompass,
  FaMap, FaMapMarkedAlt, FaRoute, FaDirections, FaArrowRight, FaArrowLeft,
  FaChevronRight, FaChevronLeft, FaChevronDown, FaChevronUp, FaPlus,
  FaMinus, FaTimes, FaInfoCircle, FaExclamationCircle, FaQuestionCircle,
  FaLightbulb, FaRocket, FaChartBar, FaChartPie, FaPercentage, FaCalculator,
  FaCreditCard, FaWallet, FaPiggyBank, FaHandHoldingUsd, FaBalanceScale,
  FaGavel, FaUniversity, FaSchool, FaGraduationCap, FaBook, FaBookmark,
  FaNewspaper, FaRss, FaBell, FaLock, FaUnlock, FaEye, FaEyeSlash,
  FaThumbtack, FaFlag, FaAnchor, FaLifeRing, FaFirstAid, FaHeartbeat,
  FaStethoscope, FaDoorOpen, FaConciergeBell, FaMoneyBillWave, FaSearchLocation, FaMoneyBill, MdEmail, FaClipboardCheck,
  FaTiktok, FaLayerGroup, FaFileContract, FaComments,
  FaCalendarCheck, FaPencilRuler, FaFileInvoiceDollar, FaBullhorn, FaUserCheck, FaHouseUser, FaStore,
   FaBalanceScaleLeft, FaExchangeAlt, FaChess, FaGlobeAsia, FaPercent, FaScroll, FaLandmark,
    FaFileSignature, FaCoins, FaSuitcase, FaBroom, FaTshirt, FaChalkboardTeacher, FaClipboardList
}